import React, { Component } from 'react';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import STRIPE_LOGO from '../../../assets/svgs/stripe.svg'
import { changeCardDetailsOnStripe, openStripePaymentMethodModal } from '../../../store/actions/paymentActions';

class CardEditingForm extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            errorMessage: "",

            accountTitle: "",
            country: "",
            city: "",
            addressLine1: "",
            addressLine2: "",
            postal: "",

            billingDetails: {},
            expMonth: "",
            expYear: "",
        }
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    handleSubmit = async (event) => {
        console.log("CARD EDIT SUBMIT")
        // Block native form submission.
        event.preventDefault();

        const { coid } = this.props.companyData;
        const { pmid, accountTitle, billingDetails, country, city, addressLine1, addressLine2, postal, expMonth, expYear } = this.state;
        var accountAddress = { ...billingDetails.address };
        accountAddress['country'] = country;
        accountAddress['city'] = city;
        accountAddress['line1'] = addressLine1;
        accountAddress['line2'] = addressLine2;
        accountAddress['postal_code'] = postal;

        var isExpiryGood = (Number.parseInt(expMonth) > 0) && (Number.parseInt(expMonth) < 13);
        if (isExpiryGood) {
            this.setState({
                errorMessage: "",
            })

            var cardDetailsObject = {
                stripePmid: pmid,
                expMonth: expMonth,
                expYear: expYear,
                accountTitle: accountTitle,
                accountAddress: accountAddress,
            }

            console.log(cardDetailsObject);
            this.props.changeCardDetailsOnStripe(cardDetailsObject, coid);
        } else {
            this.setState({
                errorMessage: "Please enter correct expiry date",
            })
        }
    }

    componentDidMount() {
        const { companyDefaultPaymentMethod } = this.props;
        const { name, address } = companyDefaultPaymentMethod.billing_details;
        const { country, postal_code, line1, line2, city } = address;
        const { exp_month, exp_year } = companyDefaultPaymentMethod.card;

        this.setState({
            pmid: companyDefaultPaymentMethod.id,
            billingDetails: companyDefaultPaymentMethod.billing_details,
            accountTitle: name,
            country: country,
            city: city,
            postal: postal_code,
            addressLine1: line1 ? line1 : "",
            addressLine2: line2 ? line2 : "",
            expMonth: exp_month,
            expYear: exp_year,
        })
    }

    render() {
        const formCheckStyle = {
            fontSize: "12px",
        };

        const formLabelStyle = {
            fontSize: "12px",
            fontWeight: "bold",
        };

        const { companyDefaultPaymentMethod, payment } = this.props;
        const { isPaymentMethodActed, isPaymentMethodActing, paymentMessage } = payment;
        const relevantComponent = !isPaymentMethodActed ? !isPaymentMethodActing ? <button className="btn btn-dark btn-sm" style={{ borderRadius: '9px' }} type="submit" disabled={isPaymentMethodActing}>Edit this card</button> : <button className="btn btn-dark btn-sm" type="button" disabled>
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            &nbsp; Updating card
        </button> : <React.Fragment />

        const relevantMessage = <p style={{ color: `${isPaymentMethodActed ? 'black' : 'red'}` }}>{paymentMessage}</p>

        return (
            <React.Fragment>
                <form onSubmit={this.handleSubmit}>
                    <h5>Card expiry</h5>
                    {/* CARD */}
                    <div className="form-row">
                        <div className="form-group col-md-6">
                            <label htmlFor="expMonth" style={formLabelStyle}>Month</label>
                            <input type="tel" className="form-control" id="expMonth" placeholder="2" maxLength="2" onChange={this.handleChange} value={this.state.expMonth} required />
                        </div>
                        <div className="form-group col-md-6">
                            <label htmlFor="expYear" style={formLabelStyle}>Year</label>
                            <input type="tel" className="form-control" id="expYear" placeholder="2025" maxLength="4" minLength="4" onChange={this.handleChange} value={this.state.expYear} required />
                        </div>
                    </div>
                    <br />
                    <h5>General details</h5>
                    {/* NAME */}
                    <div className="form-group text-left">
                        <label htmlFor="accountTitle" style={formLabelStyle}>Account name</label>
                        <input type="text" className="form-control" id="accountTitle" onChange={this.handleChange} required value={this.state.accountTitle} />
                    </div>
                    <br />

                    <h5>Billing and shipping address</h5>
                    {/* ADDRESS - Country */}
                    <div className="form-group text-left">
                        <label htmlFor="country" style={formLabelStyle}>Country code</label>
                        <input type="text" className="form-control" id="country" placeholder="Hint: GB" onChange={this.handleChange} required value={this.state.country} />
                    </div>

                    {/* ADDRESS - City */}
                    <div className="form-group text-left">
                        <label htmlFor="city" style={formLabelStyle}>City</label>
                        <input type="text" className="form-control" id="city" onChange={this.handleChange} required value={this.state.city} />
                    </div>

                    {/* ADDRESS - Line 1 */}
                    <div className="form-group text-left">
                        <label htmlFor="addressLine1" style={formLabelStyle}>Address line 1</label>
                        <input type="text" className="form-control" id="addressLine1" onChange={this.handleChange} required value={this.state.addressLine1} />
                    </div>

                    {/* ADDRESS - Line 2 */}
                    <div className="form-group text-left">
                        <label htmlFor="addressLine2" style={formLabelStyle}>Address line 2</label>
                        <input type="text" className="form-control" id="addressLine2" onChange={this.handleChange} value={this.state.addressLine2} />
                    </div>

                    {/* ADDRESS - Postal */}
                    <div className="form-group text-left">
                        <label htmlFor="postal" style={formLabelStyle}>Postal or ZIP code</label>
                        <input type="text" className="form-control" id="postal" onChange={this.handleChange} value={this.state.postal} required />
                    </div>
                    <br />
                    <p style={{ color: 'red' }}>{this.state.errorMessage}</p>
                    {relevantMessage}
                    {relevantComponent}
                </form>

                <br />
                <img src={STRIPE_LOGO} width="100px" />
            </React.Fragment>
        );
    }
}

class CardEditingModal extends Component {

    componentDidMount() {
        const { coid } = this.props.companyData;
        this.props.openStripePaymentMethodModal(coid);
    }

    render() {
        const { modalWidth, modalTitleStyle, modalInfoTextStyle, userData, companyData, payment, companyDefaultPaymentMethod, changeCardDetailsOnStripe } = this.props;

        return (
            <div className="dynamicModalContainer">
                <div className="dynamicModal">
                    <div className="px-3">
                        <p style={modalTitleStyle}>Edit your card</p>
                        <p style={modalInfoTextStyle}>Edit the details of your card.</p>
                        <br />
                        {companyDefaultPaymentMethod ?
                            <CardEditingForm userData={userData} payment={payment} companyDefaultPaymentMethod={companyDefaultPaymentMethod} companyData={companyData} changeCardDetailsOnStripe={changeCardDetailsOnStripe} />
                            : <div className="spinner-border" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,

        formLabelStyle: state.appControl.formLabelStyle,
        modalStyles: state.appControl.modalStyles,
        modalWidth: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,

        userData: state.firebase.profile,
        userId: state.firebase.auth.uid,
        companyData: state.firestore.data.Company,
        companyDefaultPaymentMethod: state.firestore.data.PaymentMethod,

        payment: state.payment,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        openStripePaymentMethodModal: (coid) => dispatch(openStripePaymentMethodModal(coid)),
        changeCardDetailsOnStripe: (cardDetailsObject, coid) => dispatch(changeCardDetailsOnStripe(cardDetailsObject, coid)),
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    firestoreConnect((props) => {
        var { stripeDefaultPmid, coid } = props.companyData;
        stripeDefaultPmid = stripeDefaultPmid ? stripeDefaultPmid === "" ? "-1" : stripeDefaultPmid : "-1";
        return [
            {
                collection: `PaymentMethods/${coid}/StripePaymentMethods`,
                storeAs: "PaymentMethod",
                doc: stripeDefaultPmid,
            },
        ]
    })
)(CardEditingModal);